module.exports = __webpack_public_path__ + "static/media/yt-guy-lighter.8ec24c24.mov";